import { render } from "./AppButton.vue?vue&type=template&id=55df82ba&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"

import "./AppButton.vue?vue&type=style&index=0&id=55df82ba&scoped=true&lang=scss"

import exportComponent from "/Users/nikita/Documents/works/novosel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55df82ba"]])

export default __exports__